// eslint-disable
import * as registry from '../registry.js'
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("en", i.count, {});
	if (count_plural == "one") return `entry`;
	if (count_plural == "other") return `entries`;
	return "widget_action_entries";
};

const de_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("de", i.count, {});
	if (count_plural == "one") return `Eintrag`;
	if (count_plural == "other") return `Einträge`;
	return "widget_action_entries";
};

const es_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("es", i.count, {});
	if (count_plural == "one") return `entrada`;
	if (count_plural == "other") return `entradas`;
	return "widget_action_entries";
};

const fr_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("fr", i.count, {});
	if (count_plural == "one") return `participation`;
	if (count_plural == "other") return `participations`;
	return "widget_action_entries";
};

const fi_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("fi", i.count, {});
	if (count_plural == "one") return `arvan`;
	if (count_plural == "other") return `arpaa`;
	return "widget_action_entries";
};

const ja_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("ja", i.count, {});
	if (count_plural == "one") return `エントリー`;
	if (count_plural == "other") return `エントリー`;
	return "widget_action_entries";
};

const nl_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("nl", i.count, {});
	if (count_plural == "one") return `deelname`;
	if (count_plural == "other") return `deelnames`;
	return "widget_action_entries";
};

const pt_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("pt", i.count, {});
	if (count_plural == "one") return `participação`;
	if (count_plural == "other") return `participações`;
	return "widget_action_entries";
};

const ro_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("ro", i.count, {});
	if (count_plural == "one") return `participare`;
	if (count_plural == "other") return `participări`;
	return "widget_action_entries";
};

const th_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("th", i.count, {});
	if (count_plural == "one") return `รายการ`;
	if (count_plural == "other") return `รายการ`;
	return "widget_action_entries";
};

const ur_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("ur", i.count, {});
	if (count_plural == "one") return `شاملی`;
	if (count_plural == "other") return `شاملیوں`;
	return "widget_action_entries";
};

const zh_hant1_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("zh-Hant", i.count, {});
	if (count_plural == "one") return `個抽獎機會`;
	if (count_plural == "other") return `個抽獎機會`;
	return "widget_action_entries";
};

const da_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("da", i.count, {});
	if (count_plural == "one") return `deltagelse`;
	if (count_plural == "other") return `deltagelser`;
	return "widget_action_entries";
};

const it_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("it", i.count, {});
	if (count_plural == "one") return `partecipazione`;
	if (count_plural == "other") return `partecipazioni`;
	return "widget_action_entries";
};

const vn_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("vn", i.count, {});
	if (count_plural == "one") return `lượt tham gia`;
	if (count_plural == "other") return `lượt tham gia`;
	return "widget_action_entries";
};

const ko_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("ko", i.count, {});
	if (count_plural == "one") return `개 참여`;
	if (count_plural == "other") return `개 참여`;
	return "widget_action_entries";
};

const tr_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("tr", i.count, {});
	if (count_plural == "one") return `katılım`;
	if (count_plural == "other") return `katılım`;
	return "widget_action_entries";
};

const lv_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("lv", i.count, {});
	if (count_plural == "one") return `ieraksts`;
	if (count_plural == "other") return `ieraksti`;
	return "widget_action_entries";
};

const ar_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("ar", i.count, {});
	if (count_plural == "one") return `مشاركة`;
	if (count_plural == "other") return `مشاركات`;
	return "widget_action_entries";
};

const bs_widget_action_entries = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const count_plural = registry.plural("bs", i.count, {});
	if (count_plural == "one") return `učešće`;
	if (count_plural == "other") return `učešća`;
	return "widget_action_entries";
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_action_entries = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_action_entries(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_action_entries", locale)
	if (locale === "en") return en_widget_action_entries(inputs)
	if (locale === "de") return de_widget_action_entries(inputs)
	if (locale === "es") return es_widget_action_entries(inputs)
	if (locale === "fr") return fr_widget_action_entries(inputs)
	if (locale === "fi") return fi_widget_action_entries(inputs)
	if (locale === "ja") return ja_widget_action_entries(inputs)
	if (locale === "nl") return nl_widget_action_entries(inputs)
	if (locale === "pt") return pt_widget_action_entries(inputs)
	if (locale === "ro") return ro_widget_action_entries(inputs)
	if (locale === "th") return th_widget_action_entries(inputs)
	if (locale === "ur") return ur_widget_action_entries(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_action_entries(inputs)
	if (locale === "da") return da_widget_action_entries(inputs)
	if (locale === "it") return it_widget_action_entries(inputs)
	if (locale === "vn") return vn_widget_action_entries(inputs)
	if (locale === "ko") return ko_widget_action_entries(inputs)
	if (locale === "tr") return tr_widget_action_entries(inputs)
	if (locale === "lv") return lv_widget_action_entries(inputs)
	if (locale === "ar") return ar_widget_action_entries(inputs)
	if (locale === "bs") return bs_widget_action_entries(inputs)
	return "widget_action_entries"
};